import { KLIPS_CTA } from "@components/cta/constants"
import { PRODUCTS, useProduct } from "./use-product"
import { useSiteMetadata } from "./use-site-metadata"
import React from "react"

// TODO: Signup seems to not really do anything? Can maybe remove
export function useCta(signup = false, productOverride, pricingModel) {
  const { location, product } = useProduct()
  const { ctaLink, ctaLinkSignup } = useSiteMetadata()
  const ctaProduct = productOverride ?? product

  const url = React.useMemo(() => {
    if (!ctaLink || !ctaLinkSignup) {
      return null
    }

    const tempUrl = new URL(signup === true ? ctaLinkSignup : ctaLink)

    tempUrl.searchParams.append(
      "start_on_metrics",
      ctaProduct === PRODUCTS.POWERMETRICS
    )

    if (location) {
      const path = location.pathname === "/" ? "/home" : location.pathname
      tempUrl.searchParams.append("page_source", path)
    }

    if (pricingModel) {
      tempUrl.searchParams.append("freemium", "true")
      tempUrl.searchParams.append("pricingModelK2", pricingModel)
    }

    tempUrl.searchParams.append("force", "true")

    return tempUrl.href
  }, [ctaLink, ctaLinkSignup, location, pricingModel])

  const cta = React.useMemo(() => {
    if (ctaProduct === PRODUCTS.AGNOSTIC) {
      return "Get Started Free"
    } else if (ctaProduct === PRODUCTS.POWERMETRICS) {
      return "Get PowerMetrics Free"
    } else {
      return "Get started with Klips"
    }
  }, [ctaProduct])

  return { ctaLink: url, product: ctaProduct, cta }
}

export function useFullCta(title, description) {
  let ctaTitle = KLIPS_CTA.title
  let ctaDescription = KLIPS_CTA.description

  if (title) ctaTitle = title
  if (description) ctaDescription = description

  const cta = React.useMemo(() => {
    return { title: ctaTitle, description: ctaDescription }
  }, [ctaTitle, ctaDescription])

  return { cta }
}
